import { isGlobalFeatureEnabled } from "owa-feature-flags";

export default function isClassicIndentedViewFlightEnabled(): boolean {
    return isGlobalFeatureEnabled("tri-ml-classic-indented-view");
}
